import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, unit_type, list_type, bool_type, option_type, int32_type, record_type, string_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { PeriodModule_toString, CancelDateChoice$reflection, Period$reflection } from "../../DomainTypes.js";
import { Result_Bind, FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { isNotNullOrWhitespace, InputType, lengthLTE } from "../../Validation/Common.js";
import { parseInt$ } from "../../Utils.js";
import { empty } from "../../fable_modules/fable-library.3.7.20/List.js";
import { CreateFeeDTOV2 } from "../../Api/Fee.js";

export class ChartOfAccount extends Record {
    constructor(AccountNo, Description, CostCentre) {
        super();
        this.AccountNo = AccountNo;
        this.Description = Description;
        this.CostCentre = CostCentre;
    }
}

export function ChartOfAccount$reflection() {
    return record_type("Containers.FeeModal.Model.ChartOfAccount", [], ChartOfAccount, () => [["AccountNo", class_type("System.Decimal")], ["Description", string_type], ["CostCentre", string_type]]);
}

export class UpdateFeeDTO extends Record {
    constructor(AmountExclVat, BoundMonths, BoundToDate, CancellationPeriodMonths, CancelledDate, ClientCrossRef, Description, FeeNumber, FeeTemplateNr, MonthsInAdvance, StartDate, VatRatePercent, AccountNo, BilledTo, Period, Units) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.BoundMonths = (BoundMonths | 0);
        this.BoundToDate = BoundToDate;
        this.CancellationPeriodMonths = CancellationPeriodMonths;
        this.CancelledDate = CancelledDate;
        this.ClientCrossRef = ClientCrossRef;
        this.Description = Description;
        this.FeeNumber = FeeNumber;
        this.FeeTemplateNr = FeeTemplateNr;
        this.MonthsInAdvance = MonthsInAdvance;
        this.StartDate = StartDate;
        this.VatRatePercent = VatRatePercent;
        this.AccountNo = AccountNo;
        this.BilledTo = BilledTo;
        this.Period = Period;
        this.Units = Units;
    }
}

export function UpdateFeeDTO$reflection() {
    return record_type("Containers.FeeModal.Model.UpdateFeeDTO", [], UpdateFeeDTO, () => [["AmountExclVat", class_type("System.Decimal")], ["BoundMonths", int32_type], ["BoundToDate", option_type(class_type("System.DateOnly"))], ["CancellationPeriodMonths", option_type(int32_type)], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["ClientCrossRef", option_type(string_type)], ["Description", option_type(string_type)], ["FeeNumber", option_type(int32_type)], ["FeeTemplateNr", option_type(int32_type)], ["MonthsInAdvance", option_type(int32_type)], ["StartDate", class_type("System.DateOnly")], ["VatRatePercent", option_type(class_type("System.Decimal"))], ["AccountNo", option_type(int32_type)], ["BilledTo", option_type(class_type("System.DateOnly"))], ["Period", option_type(string_type)], ["Units", option_type(int32_type)]]);
}

export class FeeFormTemplate extends Record {
    constructor(AmountExclVat, BoundMonths, CancellationPeriodMonths, Description, EndFeeAfterMonths, FeeTemplateNr, FeeTemplateUsage, MonthsInAdvance, UntilFurtherNotice, ValidForContractTypes, ValidForProducts, VatRatePercent, AccountNo, SortIndex, PeriodFreq, Units) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.BoundMonths = (BoundMonths | 0);
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.Description = Description;
        this.EndFeeAfterMonths = (EndFeeAfterMonths | 0);
        this.FeeTemplateNr = (FeeTemplateNr | 0);
        this.FeeTemplateUsage = (FeeTemplateUsage | 0);
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.UntilFurtherNotice = UntilFurtherNotice;
        this.ValidForContractTypes = ValidForContractTypes;
        this.ValidForProducts = ValidForProducts;
        this.VatRatePercent = VatRatePercent;
        this.AccountNo = (AccountNo | 0);
        this.SortIndex = SortIndex;
        this.PeriodFreq = PeriodFreq;
        this.Units = (Units | 0);
    }
}

export function FeeFormTemplate$reflection() {
    return record_type("Containers.FeeModal.Model.FeeFormTemplate", [], FeeFormTemplate, () => [["AmountExclVat", class_type("System.Decimal")], ["BoundMonths", int32_type], ["CancellationPeriodMonths", int32_type], ["Description", string_type], ["EndFeeAfterMonths", int32_type], ["FeeTemplateNr", int32_type], ["FeeTemplateUsage", int32_type], ["MonthsInAdvance", int32_type], ["UntilFurtherNotice", bool_type], ["ValidForContractTypes", list_type(string_type)], ["ValidForProducts", list_type(int32_type)], ["VatRatePercent", class_type("System.Decimal")], ["AccountNo", int32_type], ["SortIndex", option_type(int32_type)], ["PeriodFreq", string_type], ["Units", int32_type]]);
}

export class FeeFormViewModelValues extends Record {
    constructor(FeeTemplates, SelectedTemplate, Description, AmountExclVat, AmountInclVat, BoundMonths, BoundToDate, RemainingBoundMonths, SelectedCancellationPeriod, SelectedMonthsInAdvance, SelectedPeriod, ChosenCancelledDate, CancelledDate, SelectedAfterSomeTime, StartDate, SelectedVatRatePercent, ValidationError, ChartOfAccounts, SelectedAccountNo, UseAccountNo, BilledTo, Units) {
        super();
        this.FeeTemplates = FeeTemplates;
        this.SelectedTemplate = SelectedTemplate;
        this.Description = Description;
        this.AmountExclVat = AmountExclVat;
        this.AmountInclVat = AmountInclVat;
        this.BoundMonths = (BoundMonths | 0);
        this.BoundToDate = BoundToDate;
        this.RemainingBoundMonths = (RemainingBoundMonths | 0);
        this.SelectedCancellationPeriod = (SelectedCancellationPeriod | 0);
        this.SelectedMonthsInAdvance = (SelectedMonthsInAdvance | 0);
        this.SelectedPeriod = SelectedPeriod;
        this.ChosenCancelledDate = ChosenCancelledDate;
        this.CancelledDate = CancelledDate;
        this.SelectedAfterSomeTime = (SelectedAfterSomeTime | 0);
        this.StartDate = StartDate;
        this.SelectedVatRatePercent = SelectedVatRatePercent;
        this.ValidationError = ValidationError;
        this.ChartOfAccounts = ChartOfAccounts;
        this.SelectedAccountNo = (SelectedAccountNo | 0);
        this.UseAccountNo = UseAccountNo;
        this.BilledTo = BilledTo;
        this.Units = (Units | 0);
    }
}

export function FeeFormViewModelValues$reflection() {
    return record_type("Containers.FeeModal.Model.FeeFormViewModelValues", [], FeeFormViewModelValues, () => [["FeeTemplates", list_type(FeeFormTemplate$reflection())], ["SelectedTemplate", string_type], ["Description", string_type], ["AmountExclVat", class_type("System.Decimal")], ["AmountInclVat", class_type("System.Decimal")], ["BoundMonths", int32_type], ["BoundToDate", option_type(class_type("System.DateOnly"))], ["RemainingBoundMonths", int32_type], ["SelectedCancellationPeriod", int32_type], ["SelectedMonthsInAdvance", int32_type], ["SelectedPeriod", Period$reflection()], ["ChosenCancelledDate", CancelDateChoice$reflection()], ["CancelledDate", class_type("System.DateOnly")], ["SelectedAfterSomeTime", int32_type], ["StartDate", class_type("System.DateOnly")], ["SelectedVatRatePercent", class_type("System.Decimal")], ["ValidationError", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, list_type(string_type)], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", list_type(string_type)]]])], ["ChartOfAccounts", list_type(ChartOfAccount$reflection())], ["SelectedAccountNo", int32_type], ["UseAccountNo", bool_type], ["BilledTo", option_type(class_type("System.DateOnly"))], ["Units", int32_type]]);
}

export class String500 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["String500"];
    }
}

export function String500$reflection() {
    return union_type("Containers.FeeModal.Model.String500", [], String500, () => [[["Item", string_type]]]);
}

export function String500__get_Value(this$) {
    return this$.fields[0];
}

export function String500_create(getTranslation, str) {
    const _arg = Result_Bind((str_2) => lengthLTE(getTranslation, 500, new InputType(2), str_2), isNotNullOrWhitespace(getTranslation, str));
    if (_arg.tag === 1) {
        return new FSharpResult$2(1, _arg.fields[0]);
    }
    else {
        return new FSharpResult$2(0, new String500(0, _arg.fields[0]));
    }
}

export function String500_value_25021D(_arg) {
    return _arg.fields[0];
}

export function getCreateFeeDTOV2(invoiceeNr, contractNr, vm) {
    let matchValue, matchValue_1, matchValue_3;
    return new CreateFeeDTOV2(invoiceeNr, contractNr, parseInt$(vm.SelectedTemplate), vm.StartDate, PeriodModule_toString(vm.SelectedPeriod), vm.AmountExclVat, vm.SelectedVatRatePercent, vm.Description, vm.SelectedAccountNo, vm.SelectedMonthsInAdvance, (matchValue = vm.SelectedPeriod, (matchValue.tag === 9) ? (void 0) : ((matchValue.tag === 1) ? vm.BoundMonths : ((matchValue.tag === 2) ? vm.BoundMonths : ((matchValue.tag === 3) ? vm.BoundMonths : ((matchValue.tag === 4) ? vm.BoundMonths : ((matchValue.tag === 5) ? vm.BoundMonths : ((matchValue.tag === 6) ? vm.BoundMonths : ((matchValue.tag === 7) ? vm.BoundMonths : ((matchValue.tag === 8) ? vm.BoundMonths : (void 0)))))))))), (matchValue_1 = vm.SelectedPeriod, (matchValue_1.tag === 9) ? (void 0) : ((matchValue_1.tag === 1) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 2) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 3) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 4) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 5) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 6) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 7) ? vm.SelectedCancellationPeriod : ((matchValue_1.tag === 8) ? vm.SelectedCancellationPeriod : (void 0)))))))))), (vm.SelectedPeriod.tag === 0) ? (void 0) : ((matchValue_3 = vm.ChosenCancelledDate, (matchValue_3.tag === 1) ? vm.CancelledDate : ((matchValue_3.tag === 2) ? vm.CancelledDate : (void 0)))), empty(), vm.Units);
}

